<template>
	<div>
		<div>
			<a class="cursor-pointer" @click="$router.go(-1)">
				<svg
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 320 512"
					class="text-bold rotate180 fill-current h-3"
				>
					<path
						d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
					></path>
				</svg>
				{{ $t('back') }}
			</a>
			<h2 class="mb-4 mt-3 font-bold">
				{{ type }} {{ $t('category_contact') }}
			</h2>
			<div class="mb-4">
				<label class="block mb-2" for="category_name"
					>{{ $t('Nombre') }}
				</label>
				<input
					type="text"
					v-model="category.category_name"
					id="category_name"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.category.category_name.$dirty">
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.category.category_name.required"
					>
						{{ $t('name_required') }}
					</div>
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.category.category_name.maxLength"
					>
						{{ $t('name_validation') }}
					</div>
				</div>
			</div>

			<div class="mb-4">
				<label class="block mb-2" for="country">País</label>
				<select
					ref="country"
					id="country"
					v-model="category.country_id"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				>
					<option
						v-for="(country, index) in countries"
						:value="country.id"
						:key="index"
						:selected="country.id == category.country_id"
					>
						{{ country.name }}
					</option>
				</select>
				<div v-if="$v.category.country_id.$dirty">
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.category.country_id.required"
					>
						{{ $t('Porfavor selecciona un país') }}
					</div>
				</div>
			</div>

			<div class="mb-">
				<label class="block mb-2" for="phone">{{ $t('Orden') }}</label>
				<input
					type="number"
					v-model="category.order"
					id="order"
					class="
						w-full
						border-t-0
						border-r-0
						border-l-0
						border-b
						border-solid
						border-inputGrey
						outline-none
					"
				/>
				<div v-if="$v.category.order.$dirty">
					<div
						class="text-sm text-red-500 mt-2"
						v-if="!$v.category.order.required || !$v.category.order.numeric"
					>
						{{ $t('El orden que ha introducido no es correcto') }}
					</div>
				</div>
			</div>

			<ButtonBlack class="mt-4" @click.native="submit">
				<div v-if="loading">
					<pulse-loader
						:loading="loading"
						:color="'#fff'"
						:size="'10px'"
					></pulse-loader>
				</div>
				<div v-else>
					{{ buton_text }}
				</div>
			</ButtonBlack>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</div>
</template>

<script>
import { required, maxLength, numeric } from 'vuelidate/lib/validators'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { single } from '@/mixins'
import {
	fetchContactsCategory,
	updateContactsCategory,
	insertContactsCategory
} from '@/apollo/contactsCategories'
import { fetchCountriesSelect } from '@/apollo/countries'

export default {
	apollo: {
		category() {
			const query = fetchContactsCategory(this.id)
			query.skip = this.id == null
			return query
		},
		countries: fetchCountriesSelect()
	},
	data() {
		return {
			category: {
				category_name: '',
				order: null,
				country_id: null
			},
			section: 'contactos-categorias',
			countries: []
		}
	},
	validations() {
		return {
			category: {
				category_name: {
					required,
					maxLength: maxLength(100)
				},
				country_id: {
					required
				},
				order: {
					required,
					numeric
				}
			}
		}
	},
	components: {
		PulseLoader
	},
	mixins: [single],
	props: {
		id: String
	},
	methods: {
		submit() {
			this.startLoadingState()
			this.$v.$touch()
			if (!this.$v.$invalid) {
				this.$apollo
					.mutate(
						this.id
							? updateContactsCategory({
									categoryId: this.id,
									categoryData: this.category
							  })
							: insertContactsCategory({ category: this.category })
					)
					.then(() => this.stopLoadingState())
					.catch(error => this.setError(error))
			} else {
				this.setError(this.$t('form_validation'))
			}
		}
	}
}
</script>
<style scoped>
.rotate180 {
	-moz-transform: rotate(-180deg);
	-o-transform: rotate(-180deg);
	-webkit-transform: rotate(-180deg);
	transform: rotate(-180deg);
	display: initial;
	vertical-align: initial;
	margin-right: 5px;
}
</style>
